module.exports = __webpack_public_path__ + "img/logo.877d1b68.png";